import React from 'react';
import uniq from 'lodash/uniq';
// import { toJS } from 'mobx';

import DayEmployee from './DayEmployee';
import getEmployeeById from '../../utils/getEmployeeById';
import '../../styles/components/DayEmployees.css';

function DayEmployees ({ item, shift }) {
  let employees = null;

  if (typeof item.employees !== 'undefined' && item.employees.length) {
    employees = uniq(item.employees).map((employeeId) => {
      const employee = getEmployeeById(employeeId);

      return (
        <DayEmployee
          key={employee.id}
          employee={employee}
          shiftItem={item}
        />
      );
    });
  }

  return (
    <div className="DayEmployees">
      {employees}
      {(shift.requiredUsers > 0) ? (<small className="DayEmployees__Employee-count">{employees ? employees.length : 0} / {shift.requiredUsers}</small>) : null}
    </div>
  );
}

export default DayEmployees;



// WEBPACK FOOTER //
// ./src/components/DayModal/DayEmployees.js